"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowCommandBase = void 0;
var tslib_1 = require("tslib");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var list_1 = require("@devexpress/utils/lib/utils/list");
var command_base_1 = require("../command-base");
var RowCommandBase = (function (_super) {
    tslib_1.__extends(RowCommandBase, _super);
    function RowCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowCommandBase.prototype.canModify = function () {
        var _this = this;
        var tableInfo = this.control.selection.tableInfo;
        var table = tableInfo.table;
        return table != null && (this.control.isClientMode() ?
            list_1.ListUtils.allOf(tableInfo.rawData.rows, function (rowInfo) {
                var row = tableInfo.table.rows[rowInfo.rowIndex];
                return _this.control.selection.activeSubDocument.isEditable([fixed_1.FixedInterval.fromPositions(row.getStartPosition(), row.getEndPosition())]);
            }) : this.control.selection.activeSubDocument.isEditable([fixed_1.FixedInterval.fromPositions(table.getStartPosition(), table.getEndPosition())]));
    };
    return RowCommandBase;
}(command_base_1.CommandBase));
exports.RowCommandBase = RowCommandBase;
